import React, { createContext, useContext } from 'react'
import type { ReactNode } from 'react'

const FlowsServicesResponsesContext = createContext<Record<string, unknown> | undefined>(undefined)

export const FlowsServicesResponsesProvider = (props: {
  children: ReactNode
  servicesResponses: Record<string, unknown>
}) => {
  return (
    <FlowsServicesResponsesContext.Provider value={props.servicesResponses}>
      {props.children}
    </FlowsServicesResponsesContext.Provider>
  )
}

export const useFlowsServicesResponses = () => {
  const value = useContext(FlowsServicesResponsesContext)
  if (!value) {
    throw new Error('useFlowsServices must be used within FlowsServicesProvider')
  }
  return value
}
